import * as ActionTypes from './actionTypes';
import * as actionStatuses from './actionStatuses';

export const getNotificationMessages = (payload) => {
    return {
        type: ActionTypes.STAGE_GET_NOTIFICATION_MESSAGES,
        payload
    };
};

export const sendGetNotificationsRequest = (request, messageType, messageSource, receivedResponseLoc, communicator) => {
    return (dispatch) => {
        dispatch(sendRequestActionCreator(actionStatuses.begin,
            {
                request,
                messageType,
                messageSource
            }));

        communicator.getJsonAsync(request)
            .then((response) => {
                try {
                    switch (response.status) {
                        case 200:
                            return response.json();
                        case 204:
                            return [];
                        default:
                            console.error(`GetNotifications API Error: ${response.statusText}`);
                            return [];
                    }
                } catch (ex) {
                    console.error(`GetNotifications API Error: ${ex.message}\n${ex}`);
                    return [];
                }
            }).then((data) => {
                dispatch(sendRequestActionCreator(actionStatuses.complete, {
                        stateLocation: receivedResponseLoc,
                        messageType,
                        messageSource,
                        response: data
                    }));
            }).catch((err) => {
                dispatch(sendRequestActionCreator(actionStatuses.complete, {
                    stateLocation: receivedResponseLoc,
                    messageType,
                    messageSource,
                    response: err
                }, true));
            });
    };
};

const sendRequestActionCreator = (status, payload, error) => {
    return {
        type: ActionTypes.HANDLE_GET_NOTIFICATION_MESSAGES,
        status,
        payload,
        error
    };
};

export const stageProcessedResponse = (payload) => {
    return {
        type: ActionTypes.STAGE_PROCESSED_NOTIFICATION_RESPONSE,
        payload
    };
};

export const updatePollingStatus = (payload) => {
    return { 
        type: ActionTypes.UPDATE_POLLING_STATUS,
        payload
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/alme-notificationsapi/src/actions/actions.js